import Vue from 'vue'

import * as mutationTypes from '@/store/mutation-types.js'
import icons from '@/mixins/icons'
export default {
  name: 'Menubar',
  mixins: [icons],
  data () {
    return {}
  },
  // mounted(){
  //   var elementPosition = $('#menubar').offset();

  //   $(window).scroll(function(){
  //           if($(window).scrollTop() > elementPosition.top){
  //                 $('#menubar').css('position','fixed').css('top','0');
  //                 $('#menubar').css('z-index','9990');
  //                 $('#menubar').css('width','100%');
                
  //           } else {
  //               $('#menubar').css('position','static').css('top','0');
  //               $('#menubar').css('z-index','9990');
  //               $('#menubar').css('width','100%');
             
  //           }    
  //   });
  // },
  computed: {
    isRightSideMenuOpen () {
      return this.$store.state.menubarItems.isRightSideMenuOpen
    },
    titelbalkLinks () {
      return this.$store.state.menubarItems.left
    },
    titelbalkTitel () {
      return this.$store.state.menubarItems.title
    },
    titelbalkRechts () {
      return this.$store.state.menubarItems.right
    },
    textButtons () {
      return this.$store.state.menubarItems.rightAsTextButtons
    },
    rightSideMenuItems () {
      return this.$store.state.menubarItems.rightSideMenuItems
    }
  },
  methods: {
    toggleRightSideMenu (status, itemright) {
      if(status){
        $('body').addClass('stop-scrolling')
        $('body').bind('touchmove', function(e){e.preventDefault()})
        $('body').unbind('touchmove')
      }else{
        $('body').removeClass('stop-scrolling')
      }
      if (typeof itemright === 'undefined' || typeof itemright.cascading === 'undefined' || !itemright.cascading) {
        this.$store.commit(mutationTypes.SET_MENUBAR_RIGHT_SIDE_MENU_VISIBLE, status)
    
      }
      
    },
    executeMenubarItemCallbackFunction (item) {
      if (item.separator) {
        return ''
      }
      if (item.FUNCTIE === 'menuTogglen') {
        this.$store.commit(mutationTypes.TOGGLE_MENU)
        $('body').addClass('stop-scrolling')
        $('body').bind('touchmove', function(e){e.preventDefault()})
        $('body').unbind('touchmove')
      } else if (item.FUNCTIE === 'goBack') {
        this.goBack()
     
      } else if (typeof item.FUNCTIE !== 'undefined') {
        item.FUNCTIE()
      
      }
    },
    longpressTooltipMenubar(item) {
      return function (event) {
        if (event !== undefined) {
          event.preventDefault()
        }
        if (typeof item.FUNCTIE_HELP !== 'undefined') {
          item.FUNCTIE_HELP()
        }
      }.bind(this)
    },
    rightClickTooltipMenubar(item, event) {
      if (typeof item.FUNCTIE_HELP !== 'undefined') {
        event.preventDefault()
        item.FUNCTIE_HELP()
      }
    },
    getTextButtonClass (item) {
      return item.getTextButtonClass()
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
